// extracted by mini-css-extract-plugin
export default {"myprofile":"myprofile_myprofile__vVxTl","myprofilep":"myprofile_myprofilep__n5f2A","margin":"myprofile_margin__YIAJu"};